import { render, staticRenderFns } from "./videoDetails.vue?vue&type=template&id=bed5fc6a&"
import script from "./videoDetails.vue?vue&type=script&lang=js&"
export * from "./videoDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports